import { render, staticRenderFns } from "./Comment.vue?vue&type=template&id=5125024a&"
import script from "./Comment.vue?vue&type=script&lang=js&"
export * from "./Comment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Comment.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/gutters/Comment.vue
// module id = 894
// module chunks = 1